import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPersonSwimming, faChevronDown } from '@fortawesome/free-solid-svg-icons';
const PBTable = ({ improvements }) => {
    const hasRankings = improvements.some(pb => pb.countyRanking || pb.nationalRanking);
    return (React.createElement("div", { className: "table-container" },
        React.createElement("table", { style: { width: '100%' } },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", null, "Event"),
                    React.createElement("th", { className: "hide-on-mobile" }, "Previous PB"),
                    React.createElement("th", { className: "hide-on-mobile" }, "New PB"),
                    React.createElement("th", { className: "hide-on-mobile" }, "Improvement"),
                    hasRankings && React.createElement("th", { className: "hide-on-mobile" }, "Rankings"))),
            React.createElement("tbody", null, improvements.map((pb, i) => {
                const rankingMeta = [
                    pb.countyRanking ? `County #${pb.countyRanking}${pb.countyTotal ? `/${pb.countyTotal}` : ''}` : null,
                    pb.nationalRanking ? `National #${pb.nationalRanking}${pb.nationalTotal ? `/${pb.nationalTotal}` : ''}` : null,
                ].filter(Boolean).join(' · ');
                return (React.createElement("tr", { key: i },
                    React.createElement("td", { "data-label": "Event", className: "card-event-td" },
                        React.createElement("div", { className: "card-event-header" },
                            React.createElement("div", null,
                                pb.event,
                                "\u00A0",
                                React.createElement("span", { className: "swimmer-tag-badge" }, pb.course === '50m' ? 'LC' : 'SC')),
                            React.createElement("span", { className: "mobile-supplement card-inline-time faster" }, pb.newTime)),
                        React.createElement("div", { className: "mobile-supplement card-meta-row" },
                            pb.previousBest ? `Was: ${pb.previousBest}` : 'New event',
                            pb.improvement ? ` · −${pb.improvement}` : ''),
                        rankingMeta && (React.createElement("div", { className: "mobile-supplement card-meta-row" }, rankingMeta))),
                    React.createElement("td", { "data-label": "Previous PB", className: "hide-on-mobile", style: { color: 'var(--text-secondary)' } }, pb.previousBest ?? '—'),
                    React.createElement("td", { "data-label": "New PB", className: "hide-on-mobile faster" }, pb.newTime),
                    React.createElement("td", { "data-label": "Improvement", className: "hide-on-mobile faster" }, pb.improvement ? `−${pb.improvement}` : '—'),
                    hasRankings && (React.createElement("td", { "data-label": "Rankings", className: "hide-on-mobile", style: { fontSize: '0.85rem' } },
                        pb.countyRanking
                            ? React.createElement("div", null,
                                "County: ",
                                React.createElement("strong", null,
                                    "#",
                                    pb.countyRanking),
                                pb.countyTotal ? React.createElement("span", { style: { color: 'var(--text-secondary)' } },
                                    " of ",
                                    pb.countyTotal) : '')
                            : null,
                        pb.nationalRanking
                            ? React.createElement("div", null,
                                "National: ",
                                React.createElement("strong", null,
                                    "#",
                                    pb.nationalRanking),
                                pb.nationalTotal ? React.createElement("span", { style: { color: 'var(--text-secondary)' } },
                                    " of ",
                                    pb.nationalTotal) : '')
                            : null,
                        !pb.countyRanking && !pb.nationalRanking ? '—' : null))));
            })))));
};
const ImprovementsModal = ({ swimmers, onClose }) => {
    const [collapsed, setCollapsed] = useState(new Set());
    const toggle = (name) => {
        setCollapsed(prev => {
            const next = new Set(prev);
            if (next.has(name))
                next.delete(name);
            else
                next.add(name);
            return next;
        });
    };
    const multiSwimmer = swimmers.length > 1;
    const title = multiSwimmer
        ? 'New Personal Bests'
        : `New Personal Bests — ${swimmers[0].swimmerName}`;
    return (React.createElement("div", { className: "modal-backdrop", onClick: onClose },
        React.createElement("div", { className: "modal", onClick: e => e.stopPropagation() },
            React.createElement("div", { className: "modal-header" },
                React.createElement("h3", null, title),
                React.createElement("button", { className: "modal-close", onClick: onClose, "aria-label": "Close" }, "\u00D7")),
            React.createElement("div", { className: "modal-body", style: { padding: 0 } }, multiSwimmer ? (swimmers.map(({ swimmerName, improvements }, idx) => (React.createElement("div", { key: swimmerName, className: `club-group${idx > 0 ? ' club-group-spaced' : ''}` },
                React.createElement("div", { className: "club-header", onClick: () => toggle(swimmerName) },
                    React.createElement("h3", { className: "club-header-title" },
                        React.createElement(FontAwesomeIcon, { icon: faPersonSwimming }),
                        "\u00A0",
                        swimmerName,
                        "\u00A0",
                        React.createElement("span", { className: "swimmer-tag-badge" },
                            "New PBs: ",
                            improvements.length)),
                    React.createElement(FontAwesomeIcon, { icon: faChevronDown, className: `chevron-icon${!collapsed.has(swimmerName) ? ' expanded' : ''}` })),
                !collapsed.has(swimmerName) && (React.createElement(PBTable, { improvements: improvements })))))) : (React.createElement(PBTable, { improvements: swimmers[0].improvements ?? [] }))),
            React.createElement("div", { className: "modal-actions" },
                React.createElement("button", { type: "button", className: "btn", onClick: onClose }, "Close")))));
};
export default ImprovementsModal;
